import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')
const PrivacyPolicy = () => import('@/views/PrivacyPolicy')

const Products = () => import('@/views/Products/ProductsList')
const ProductsAdd = () => import('@/views/Products/ProductsAdd')
const ProductsEdit = () => import('@/views/Products/ProductsEdit')

const Members = () => import('@/views/Members/MembersList')
const MembersAdd = () => import('@/views/Members/MembersAdd')
const MembersEdit = () => import('@/views/Members/MembersEdit')

const Prizes = () => import('@/views/Prizes/PrizesList')
const PrizesAdd = () => import('@/views/Prizes/PrizesAdd')
const PrizesEdit = () => import('@/views/Prizes/PrizesEdit')

const Heros = () => import('@/views/Heros/HerosList')
const HerosAdd = () => import('@/views/Heros/HerosAdd')
const HerosEdit = () => import('@/views/Heros/HerosEdit')

const KeyValues = () => import('@/views/KeyValues/KeyValuesList')
const KeyValuesAdd = () => import('@/views/KeyValues/KeyValuesAdd')
const KeyValuesEdit = () => import('@/views/KeyValues/KeyValuesEdit')

const StaticInfos = () => import('@/views/StaticInfos/StaticInfosList')
const StaticInfosAdd = () => import('@/views/StaticInfos/StaticInfosAdd')
const StaticInfosEdit = () => import('@/views/StaticInfos/StaticInfosEdit')

const MenuItems = () => import('@/views/MenuItems/MenuItemsList')
const MenuItemsAdd = () => import('@/views/MenuItems/MenuItemsAdd')
const MenuItemsEdit = () => import('@/views/MenuItems/MenuItemsEdit')

const Settings = () => import('@/views/Settings')
const Profile = () => import('@/views/Profile')
const Page404 = () => import('@/views/Page404')
const Page500 = () => import('@/views/Page500')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/produtos',
      name: 'Products',
      component: TheContainer,
      children: [
        // Products
        {
          path: 'produtos',
          redirect: '/produtos/lista',
          name: 'Products',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'ProductsList',
              component: Products
            },
            {
              path: 'adicionar',
              name: 'ProductsAdd',
              component: ProductsAdd
            },
            {
              path: 'editar',
              name: 'ProductsEdit',
              component: ProductsEdit
            },
          ]
        },
        // Members
        {
          path: 'membros',
          redirect: '/membros/lista',
          name: 'Members',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'MembersList',
              component: Members
            },
            {
              path: 'adicionar',
              name: 'MembersAdd',
              component: MembersAdd
            },
            {
              path: 'editar',
              name: 'MembersEdit',
              component: MembersEdit
            },
          ]
        },
        // Prizes
        {
          path: 'premios',
          redirect: '/premios/lista',
          name: 'Prizes',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'PrizesList',
              component: Prizes
            },
            {
              path: 'adicionar',
              name: 'PrizesAdd',
              component: PrizesAdd
            },
            {
              path: 'editar',
              name: 'PrizesEdit',
              component: PrizesEdit
            },
          ]
        },
        // Heros
        {
          path: 'capa',
          redirect: '/capa/lista',
          name: 'Heros',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'HerosList',
              component: Heros
            },
            {
              path: 'adicionar',
              name: 'HerosAdd',
              component: HerosAdd
            },
            {
              path: 'editar',
              name: 'HerosEdit',
              component: HerosEdit
            },
          ]
        },
        // KeyValues
        {
          path: 'informacoes',
          redirect: '/informacoes/lista',
          name: 'KeyValues',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'KeyValuesList',
              component: KeyValues
            },
            {
              path: 'adicionar',
              name: 'KeyValuesAdd',
              component: KeyValuesAdd
            },
            {
              path: 'editar',
              name: 'KeyValuesEdit',
              component: KeyValuesEdit
            },
          ]
        },
        // StaticInfos
        {
          path: 'paginas',
          redirect: '/paginas/lista',
          name: 'StaticInfos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'StaticInfosList',
              component: StaticInfos
            },
            {
              path: 'adicionar',
              name: 'StaticInfosAdd',
              component: StaticInfosAdd
            },
            {
              path: 'editar',
              name: 'StaticInfosEdit',
              component: StaticInfosEdit
            },
          ]
        },
        // MenuItems
        {
          path: 'menu',
          redirect: '/menu/lista',
          name: 'MenuItems',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'MenuItemsList',
              component: MenuItems
            },
            {
              path: 'adicionar',
              name: 'MenuItemsAdd',
              component: MenuItemsAdd
            },
            {
              path: 'editar',
              name: 'MenuItemsEdit',
              component: MenuItemsEdit
            },
          ]
        },
        // Settings
        {
          path: 'definicoes',
          name: 'Settings',
          component: Settings
        },
        // Profile
        {
          path: 'perfil',
          name: 'Profile',
          component: Profile
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/404',
      name: '404',
      component: Page404
    },    
    {
      path: '/500',
      name: '500',
      component: Page500
    }, 
  ]
}

